const actionType = {
    delete: 'delete',
    update: 'update',
    add: 'add',
    start: 'start',
    stop: 'stop',
    attach:'attach',
    detach:'detach'
};

export default actionType;